import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './Store'
import firebase from 'firebase/app';
import "firebase/auth"
import firebaseMsg from '@firebase/messaging'
import  './config/FirebaseInit'
import BootstrapVue from 'bootstrap-vue'

import VueBarcodeScanner from 'vue-barcode-scanner'
// inject barcode scanner with option (add sound effect)
// sound will trigger when it's already scanned
let options = {
  sound: false, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 10, // default is 100
  requiredAttr: false, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options)


// import VueHtmlToPaper from 'vue-html-to-paper';
// const printOptions = {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes'
//   ],
//   styles: [

//     '../static/pos.css'
//   ],
//   timeout: 1000, // default timeout before the print window appears
//   autoClose: true, // if false, the window will not close after printing
//   windowTitle: window.document.title, // override the window title
// }
// Vue.use(VueHtmlToPaper,printOptions);

// var SocialSharing = require('vue-social-sharing');
// Vue.use(SocialSharing)

// import { Icon }  from 'leaflet'
// import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
// delete Icon.Default.prototype._getIconUrl;
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

// import * as VueGoogleMaps from 'vue2-google-maps'
// import VueTypedJs from 'vue-typed-js'
// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import VuePwaInstallPlugin from "vue-pwa-install";
// Vue.use(VuePwaInstallPlugin);
import Carousel3d from 'vue-carousel-3d'
import VModal from 'vue-js-modal'
import ProductZoomer from 'vue-product-zoomer'
import zoom from 'vue-image-zoom';
import 'vue-image-zoom/dist/vue-image-zoom.css';
// import VueCharts from 'hchs-vue-charts';


// import VeeValidate from 'vee-validate';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/element-ui-index.css';

import BackToTop from 'vue-backtotop'

Vue.use(BackToTop)
// const router = new Router({
//   routes,
//   mode:'history'
// })
// import jQuery from 'jQuery'
// global.jQuery = jQuery
// global.$ = jQuery
Vue.use(zoom);
// Vue.use(window.VueCharts);
// Vue.use(VueFormWizard)
Vue.use(ProductZoomer)
Vue.use(VModal)
Vue.use(Carousel3d)
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.use(BootstrapVue);
Vue.use(ElementUI, { locale });
// Vue.use(VueTypedJs)

// Vue.use(VeeValidate);
Vue.config.productionTip = true

export const bus = new Vue()

let app;
firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    new Vue({
      store:store,
      el: '#app',
      router,
      render: h => h(App)
    });
  }
})

// Vue.prototype.$messaging = firebase.messaging()
// Vue.prototype.$messaging.usePublicVapidKey("BOM7o4aqlQ3j8BKb4xN5626BIOSiJP0RerrA3RMrIlVw4WSIKjRB_dfCvQluDAh5J_6R4vlnHYUhd6jSVZo9th4");
// navigator.serviceWorker.register('../static/firebase-messaging-sw.js')
//   .then((registration) => {
//     Vue.prototype.$messaging.useServiceWorker(registration)
//   }).catch(err => {
//     alert(err)
//   })
// Vue.use(VueGoogleMaps, {
//  load: {
//    key: '',
//    v: 'quarterly',

//  },

// })
/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js